import React from 'react';
import SearchResultItem from './SearchResultItem';

export default function SearchResultsWrapper({ results, nbResults, searchData }) {
  return (
    <div className="crtInner">
      {searchData.hasOwnProperty('resultsWording') ? (
        <h1 className="crtTitle-2">{nbResults + ' ' + searchData.resultsWording}</h1>
      ) : null}
      {results.map((element) => (
        <SearchResultItem teaser={element.teaser} key={element.objectID} />
      ))}
    </div>
  );
}
